// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Images/UNILUS.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.OurStrengthCover{
     height: 100vh;
     background-color: #003300;
     /* background-image: url("../../Images/UnilusBGWhole.jpg"); */
     background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
     background-size: cover;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: space-evenly;
}

.innerContent{
    position: absolute;
    width: 90%;
    height: 80%;
    
    background-color: rgb(247, 247, 241);
    z-index: 2;
    /* background-color: red; */
    padding: 0;
    margin: 0;
}
.innerContent .CMSWording{
    
    padding: 0;
    margin: 0;
}

.ourStrengthWording{
    text-align: center;
}

.OurStrengthCardsCover{
    display: flex;
    
    justify-content: space-between;
    margin: 10px;
    gap: 50px;
    padding: 0 30px;
}
.OurStrengthCard{
    text-align: center;
    /* max-width: 300px; */
}

.fontIcon{
    font-size: 2rem;
}


@media screen and (max-width: 730px){   


    .OurStrengthCover{
        height: 1200px;
        overflow: hidden;
     
   }

    
.OurStrengthCardsCover{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px;
    gap: 10px;
    padding: 0 30px;
    overflow: hidden;
}   

.innerContent{
    position: absolute;
    width: 90%;
    height: auto;
    
    /* background-color:red; */
    z-index: 2;
    /* background-color: red; */
    padding: 0;
    margin: 0;
}
    
  


    
        
    
}
`, "",{"version":3,"sources":["webpack://./src/Components/OurStrength/OurStrength.css"],"names":[],"mappings":";;;AAGA;KACK,aAAa;KACb,yBAAyB;KACzB,6DAA6D;KAC7D,yDAAgD;KAChD,sBAAsB;KACtB,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,6BAA6B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;;IAEX,oCAAoC;IACpC,UAAU;IACV,2BAA2B;IAC3B,UAAU;IACV,SAAS;AACb;AACA;;IAEI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;;IAEb,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;;AAGA;;;IAGI;QACI,cAAc;QACd,gBAAgB;;GAErB;;;AAGH;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;;IAEZ,0BAA0B;IAC1B,UAAU;IACV,2BAA2B;IAC3B,UAAU;IACV,SAAS;AACb;;;;;;;;AAQA","sourcesContent":["\n\n\n.OurStrengthCover{\n     height: 100vh;\n     background-color: #003300;\n     /* background-image: url(\"../../Images/UnilusBGWhole.jpg\"); */\n     background-image: url(\"../../Images/UNILUS.jpg\");\n     background-size: cover;\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     justify-content: space-evenly;\n}\n\n.innerContent{\n    position: absolute;\n    width: 90%;\n    height: 80%;\n    \n    background-color: rgb(247, 247, 241);\n    z-index: 2;\n    /* background-color: red; */\n    padding: 0;\n    margin: 0;\n}\n.innerContent .CMSWording{\n    \n    padding: 0;\n    margin: 0;\n}\n\n.ourStrengthWording{\n    text-align: center;\n}\n\n.OurStrengthCardsCover{\n    display: flex;\n    \n    justify-content: space-between;\n    margin: 10px;\n    gap: 50px;\n    padding: 0 30px;\n}\n.OurStrengthCard{\n    text-align: center;\n    /* max-width: 300px; */\n}\n\n.fontIcon{\n    font-size: 2rem;\n}\n\n\n@media screen and (max-width: 730px){   \n\n\n    .OurStrengthCover{\n        height: 1200px;\n        overflow: hidden;\n     \n   }\n\n    \n.OurStrengthCardsCover{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin: 10px;\n    gap: 10px;\n    padding: 0 30px;\n    overflow: hidden;\n}   \n\n.innerContent{\n    position: absolute;\n    width: 90%;\n    height: auto;\n    \n    /* background-color:red; */\n    z-index: 2;\n    /* background-color: red; */\n    padding: 0;\n    margin: 0;\n}\n    \n  \n\n\n    \n        \n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
